/* eslint-disable no-use-before-define */
import React from 'react';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

export const BtnAddBasket = ({ onClick, data }) => {
    return (
        <ShoppingCartIcon onClick={onClick} />
    )
};